import { permMgrApiUrl, idURL } from 'endpoints';
import fetch from '../utils/fetch';


//For dev only
// import { idURL } from 'endpoints';
// const permMgrApiUrl = 'http://localhost:3000/api/v1';

//For coexistance effort only
let permMgrApiUrlV3 = permMgrApiUrl + '/v3';

class PermissionsSDK {
    getGroup = async( groupId ) => {
        return new Promise( ( resolve, reject ) => {
        fetch( `${ permMgrApiUrl }/group/roster/${ groupId }`, {
            method: 'GET'
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                res.json().then( ( data ) => {
                    resolve( data.group );
                } );
            } else {
                res.json().then( ( data ) => {
                    reject( data.message );
                } );
            }
        } )
        .catch ( ( err ) => {
            reject( err.message );
        } );
    } );
    };
    getOldGroup = async( groupId ) => {
        return new Promise( ( resolve, reject ) => {
        fetch( `${ permMgrApiUrl }/group/${ groupId }`, {
            method: 'GET'
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                res.json().then( ( data ) => {

                    resolve( data.newGroupData );
                } );
            } else {
                res.json().then( ( data ) => {
                    reject( data.message );
                } );
            }
        } )
        .catch ( ( err ) => {
            reject( err.message );
        } );
    } );
    };
    getAllGroups = async() => {
        return new Promise( ( resolve, reject ) => {
        fetch( `${ permMgrApiUrl }/groups`, {
            method: 'GET'
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                res.json().then( ( data ) => {

                    resolve( data.newGroupData );
                } );
            } else {
                res.json().then( ( data ) => {
                    reject( data.message );
                } );
            }
        } )
        .catch ( ( err ) => {
            reject( err.message );
        } );
    } );
    };
    saveNewGroup = async( group ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/group/add`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( { group: group } )
            } ).then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data.newGroupData );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    deleteGroup = async( groupId ) => {

        return new Promise( ( resolve, reject ) => {
        fetch( `${ permMgrApiUrl }/group/delete/${ groupId }`, {
            method: 'GET'
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                res.json().then( ( data ) => {
                    resolve( data );
                } );
            } else {
                res.json().then( ( data ) => {
                    reject( data.message );
                } );
            }
        } )
        .catch ( ( err ) => {
            reject( err.message );
        } );
    } );
    };

    getAppPermissions = async() => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/appPermissions`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data.appPermissionsData );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getUsers = async() => {
        return new Promise( ( resolve, reject ) => {
        fetch( `${ idURL }/api/v1/accounts`, {
            method: 'GET'
        } )
        .then( ( res ) => {
            if ( res.ok ) {
                res.json().then( ( data ) => {

                    resolve( data );
                } );
            } else {
                res.json().then( ( data ) => {
                    reject( data.message );
                } );
            }
        } )
        .catch ( ( err ) => {
            reject( err.message );
        } );
    } );
    };
    getPermissions = async() => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/newAppPermissions`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data.permissionsData );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getPermission = async( id ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/permission/${ id }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getPolicies = async() => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/policies`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getPolicy = async( policyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/policy/${ policyId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    deletePolicy = async( policyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/policy`, {
                method: 'DELETE',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        policy: {
                            id: policyId
                        }
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    savePolicy = async( policy ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/policy`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        policy: {
                            id: policy.id ? policy.id : undefined,
                            permissions: policy.selectedPermissions,
                            name: policy.name,
                            wildcards: policy.selectedWildcards
                        }
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRoles = async() => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/detailed/roles`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRolesV3 = async() => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/detailed/roles`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRolesByCompany = async( companyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/detailed/roles/${ companyId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRolesByCompanyV3 = async( companyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/detailed/roles/${ companyId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRoleByCompany = async( roleId, companyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/detailed/roles/${ companyId }/${ roleId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRoleByCompanyV3 = async( roleId, companyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/detailed/roles/${ companyId }/${ roleId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRole = async( roleId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/detailed/role/${ roleId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    getRoleV3 = async( roleId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/detailed/role/${ roleId }`, {
                method: 'GET'
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    deleteRole = async( roleId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/role`, {
                method: 'DELETE',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        role: {
                            id: roleId
                        }
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    deleteRoleV3 = async( roleId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/role`, {
                method: 'DELETE',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        role: {
                            id: roleId
                        }
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    saveRole = async( role ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/role`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        role
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    saveRoleV3 = async( role ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/role`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        role
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    shareRole = async( role ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/share/role/${ role.id }`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        role
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    shareRoleV3 = async( role, companyId ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/share/role/${ role.id }/${ companyId }`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        role
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                reject( err.message );
            } );
        } );
    };
    searchPersons = async( searchString ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/persons/search`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        searchString
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };
    searchPersonsSimple = async( searchString ) => {

        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/persons/getpersons`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        searchString
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };
    addGroupToRoleByCompany = async( group, roleId, companyId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrl }/groups/addcompanyrole`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        group: group,
                        roleId: roleId,
                        companyId: companyId
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };
    addGroupToRoleByCompanyV3 = async( group, roleId, companyId ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ permMgrApiUrlV3 }/groups/addcompanyrole`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(
                    {
                        group: group,
                        roleId: roleId,
                        companyId: companyId
                    }
                )
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };
}

export default new PermissionsSDK();
